import React from 'react';
import { InputNumber, Form } from 'antd';

function PWCInput(formItemInfo) {
  return (
    <Form.Item
      required={formItemInfo.required}
      name={formItemInfo.name}
      label={formItemInfo.label}
      rules={formItemInfo.rules}
      className={formItemInfo.className}
      style={formItemInfo.formItemStyle}
    >
      <InputNumber
        style={{ background: 'transparent' }}
        // placeholder="Please input"
        autoComplete="off"
        {...formItemInfo.compProps}
      />
    </Form.Item>
  );
}

export default PWCInput;
